export default defineNuxtPlugin((nuxtApp) => {
  const toaster = useToaster()
  const { t } = nuxtApp.$i18n
  const toasterTheme = {
    maxToasts: 5,
    containerId: 'top-center',
    containerClass: [
      'fixed',
      'inset-0',
      'pointer-events-none',
      'p-4',
      'flex',
      'flex-col', // top
      'overflow-hidden',
      'z-[10000]',
      'items-center', // center
      'gap-2',
      'space-y-3',
    ],
    wrapperClass: [
      'pointer-events-auto',
      'focus:outline-none',
      'rounded',
      'outline-slate-300',
      'outline-offset-2',
      'focus:outline',
      'focus:outline-2',
      'focus-within:outline',
      'focus-within:outline-2',
      'z-[10000]',
    ],
    transition: {
      enterActiveClass: 'transition duration-300 ease-out',
      enterFromClass: 'transform -translate-y-full opacity-0',
      enterToClass: 'transform translate-y-0 opacity-100',
      leaveActiveClass: 'transition duration-200 ease-in',
      leaveFromClass: 'transform translate-y-0 opacity-100',
      leaveToClass: 'transform -translate-y-full opacity-0',
    },
  }
  const notification = {
    error: (error) => {
      let message
      // Handle different errors
      console.error('Notification Error:', error)
      if (typeof error === 'object' && (error?.name === 'NotAuthenticated' || error?.type === 'FeathersError')) {
        message = error.message
      } else {
        message = t(error.message)
      }
      toaster.show({
        title: error.title || t('general.error'),
        //message: message,
        color: 'danger',
        icon: 'lucide:alert-octagon',
        closable: true,
      },{ theme: toasterTheme })
    },
    info: (message) => {
      if (typeof message === 'object') {
        message = message.message
      } else {
        message = t(message.message)
      }
      toaster.show({
        title: message.title || t('general.info'),
        //message: message,
        color: 'info',
        icon: 'lucide:info',
        closable: true,
      },{ theme: toasterTheme })
    },
    success: (message) => {
      toaster.show({
        title: message.title || t('general.success'),
        //message: message,
        color: 'success',
        icon: 'lucide:check',
        closable: true,
      },{ theme: toasterTheme })
    },
  }

  return {
    provide: {
      notification
    },
  }
})
